import React, { useState, useEffect } from "react";

/** Graphql */
import { fetchQuery } from 'react-relay';
import getAllCountryQuery from '../../../graphql/country/queries/getAllCountryQuery';
import getAllGovernorateQuery from '../../../graphql/governorate/queries/getAllGovernorateQuery';
import CreateCityMutation from '../../../graphql/city/mutations/CreateCityMutation';
import environment from '../../../graphql/Environment';



import { useForm } from 'react-hook-form';
import { ButtonSave, ButtonCancel } from '../../../components/Buttons';


const Form = (props) => {


    const { defaultData, countries, getGovernorates } = props;

    const {
        register,
        handleSubmit,
        errors,
        setValue
    } = useForm({
        mode: "onChange",
        defaultValues: defaultData
    });



    /**
* 
*/
    useEffect(() => { }, [register]);

    const [governorates, setGovernorates] = useState(props?.governorates || []);


    /**
     * 
     * @param {*} e 
     */
    const countryChanged = (countryId) => {
        setValue('governorateId', '');
        getGovernorates({ where: { 'countryId': countryId } })
            .then(data => {
                const { items } = data.getAllGovernorate;
                setGovernorates(items);
            }).catch(error => {
                console.log('error :', error.message);
            });
    }


    /**
     * 
     * @param {*} data 
     */
    const create = data => {
        CreateCityMutation({ ...data }, (response) => {
            if (response.status === 'OK') {
                props.doClose({
                    ...response, msgSnackbar: {
                        message: 'C bon c fait',
                        variant: 'success',
                        open: true,
                    }
                });
            } else {
                console.log({ error: 'Erreur' });
            }

        });
    }


    /**
     * 
     * @param {*} data 
     */
    const onSubmit = data => create(data);

    return (


        <form onSubmit={handleSubmit(onSubmit)} className="row p-5" >
            <div className="form-group col-md-6">
                <label className="col-form-label text-secondary">Pays:</label>
                <div className="">

                    <select
                        name="countryId"
                        onChange={(e) => countryChanged(e.target.value)}
                        className={
                            errors.countryId
                                ? "form-control form-control-sm is-invalid"
                                : "form-control form-control-sm"}
                        ref={register({ required: true })} >
                        <option value=""></option>
                        {
                            countries.map(item => <option key={item.id} value={item.id}>{item.name}</option>)
                        }
                    </select>

                    {errors.countryId && (
                        <div className="invalid-feedback">This field is required</div>
                    )}
                </div>

            </div>

            <div className="form-group col-md-6">
                <label className="col-form-label text-secondary">Gouvernorat:</label>
                <div className="">

                    <select
                        name="governorateId"
                        className={
                            errors.governorateId
                                ? "form-control form-control-sm is-invalid"
                                : "form-control form-control-sm"}
                        ref={register({ required: true })} >
                        <option value=""></option>
                        {
                            governorates.map(item => <option key={item.id} value={item.id}>{item.name}</option>)
                        }
                    </select>

                    {errors.governorateId && (
                        <div className="invalid-feedback">This field is required</div>
                    )}
                </div>

            </div>

            <div className="form-group col-md-6">
                <label className="col-form-label text-secondary">Libelle:</label>
                <div className="">
                    <input
                        type="text"
                        name="name"
                        className={
                            errors.name
                                ? "form-control form-control-sm is-invalid"
                                : "form-control form-control-sm"}
                        ref={register({ required: true })} />
                    {errors.name && <span className="invalid-feedback">This field is required</span>}
                </div>

            </div>

            <div className="form-group col-md-6">
                <label className="col-form-label text-secondary">Code postal:</label>
                <div className="">
                    <input
                        type="text"
                        name="zipCode"
                        className={
                            errors.zipCode
                                ? "form-control form-control-sm is-invalid"
                                : "form-control form-control-sm"}
                        ref={register({ required: true })} />
                    {errors.zipCode && <span className="invalid-feedback">This field is required</span>}
                </div>

            </div>


            <div className="form-group col-md-12 text-right mt-2">

                <ButtonCancel onClick={() => props.doClose()}></ButtonCancel>
                <ButtonSave type="submit"></ButtonSave>

            </div>
        </form>
    );
}


export default (props) => {


    /**
    * 
    */
    const [state, setState] = useState({
        dataLoaded: false,
        defaultData: {},
        countries: [],
        governorates: []
    });


    useEffect(() => {
        loadData();
    }, []);



    /**
       * 
       */
    const loadData = () => {
        Promise.all([loadCountries()])
            .then(data => {
                const [{ getAllCountry }] = data;
                const defaultData = getDefaultData();
                setState({
                    ...state,
                    dataLoaded: true,
                    countries: getAllCountry.items,
                    defaultData: defaultData
                });
            })
            .catch(error => {
                console.log('error :', error.message);
            });
    }


    /**
* 
*/
    const loadCountries = (gqlQueryParam = {}) => {
        return fetchQuery(environment, getAllCountryQuery, gqlQueryParam);

    }


    /**
* 
*/
    const getGovernorates = (gqlQueryParam = {}) => {
        return fetchQuery(environment, getAllGovernorateQuery, gqlQueryParam);

    }



    const getDefaultData = () => {

        return {
            name: '',
            zipCode: '',
            countryId: null,
            governorateId: null,
        };

    }



    return (
        <>
            {
                state.dataLoaded ?
                    (<Form
                        defaultData={state.defaultData}
                        countries={state.countries}
                        getGovernorates={getGovernorates}
                        {...props} />)
                    : '...Loading'
            }
        </>
    )

}